export const USER_REQUEST = 'USER_REQUEST'
export const USER_SUCCESS = 'USER_SUCCESS'
export const USER_ERROR = 'USER_ERROR'
export const USER_PLAYER_ID_REQUEST = 'USER_PLAYER_ID_REQUEST'
export const USER_PLAYER_ID_SUCCESS = 'USER_PLAYER_ID_SUCCESS'
export const USER_PLAYER_MESSAGING = 'USER_PLAYER_MESSAGING'